import React, { createContext, useContext, useState, useCallback } from 'react';

// Global appearance theme for the authenticated app shell.
//   light   → light chrome + light content (default, enterprise)
//   dark    → dark chrome + dark content
//   branded → deep-indigo branded sidebar + light content
const ThemeCtx = createContext(null);
export const useTheme = () => useContext(ThemeCtx) || { mode: 'light', setMode: () => {} };

const MODES = ['light', 'branded'];

export function ThemeProvider({ children }) {
  const [mode, setModeState] = useState(() => {
    try {
      const v = localStorage.getItem('iw_app_theme');
      return MODES.includes(v) ? v : 'light'; // legacy 'dark' → light
    } catch { return 'light'; }
  });
  const setMode = useCallback((m) => {
    const next = MODES.includes(m) ? m : 'light';
    setModeState(next);
    try { localStorage.setItem('iw_app_theme', next); } catch {}
  }, []);
  // Content stays light in both modes (branded only re-skins the sidebar).
  const appTheme = 'light';
  return (
    <ThemeCtx.Provider value={{ mode, setMode, appTheme }}>
      {children}
    </ThemeCtx.Provider>
  );
}
